export default {
  left: {
    group: 'My group',
    location: 'Schedule location',
    description: 'Schedule description',
    scoreChart: 'Score sheet',
    scoreChartDescription: 'Score sheet description',
  },
  logout: 'Logout',
  right: {
    title: 'Interviewer Rating Confirmation Form',
    project: 'Project',
    scheduleDate: 'Interview Date',
    scoreChart: 'Score sheet',
    interviewer: 'Interviewer',
    name: 'Interview Name',
    placeholder: 'All arrangements',
  },
  footer: {
    tip: 'Please confirm that the above rating and comment are correct. After confirming the signature, it will not be modified.',
    signature: 'Signature',
    date: 'Date',
    signatureButton: 'Click to sign',
    signatureDraw: 'Please sign within this area',
    signatureConfirm: 'Please check the signature before submitting, it cannot be changed after submitting.',
    buttonConfirm: 'Confirm',
    buttonClear: 'Clear',
    success: 'Thank you for completing the task',
    confirm: 'Confirm',
  },
  titleShow: 'Interviewer Rating Confirmation Form',
  signOutConfirm: 'Sign out of the interview scoring system?',
  signOutCancel: 'Sign-out canceled',
  error401: 'Login expired, please log in again',
};
